<template>
  <AdminAppLayout title="HR-DOS | Leave Requests">
      
    <div class="row">
      <div class="col s12 m6">
        <div class="card green darken-1 z-depth-2" style="border-radius: 8px;">
          <div class="card-content white-text" style="padding: 25px;">
            <div class="valign-wrapper" style="margin-bottom: 15px;">
              <i class="material-icons" style="background: rgba(255,255,255,0.2); padding: 5px; border-radius: 4px; margin-right: 15px;">event_available</i>
              <span style="font-size: 1.2rem; font-weight: 500;">Vacation Leave Credits</span>
            </div>
            <div class="valign-wrapper">
              <span style="font-size: 3rem; font-weight: bold; margin-right: 10px; line-height: 1;">
                {{ balances?.vacation_leave_credits || '0.0' }}
              </span>
              <span style="font-size: 1.1rem; opacity: 0.9;">Days Remaining</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col s12 m6">
        <div class="card blue darken-1 z-depth-2" style="border-radius: 8px;">
          <div class="card-content white-text" style="padding: 25px;">
            <div class="valign-wrapper" style="margin-bottom: 15px;">
              <i class="material-icons" style="background: rgba(255,255,255,0.2); padding: 5px; border-radius: 4px; margin-right: 15px;">post_add</i>
              <span style="font-size: 1.2rem; font-weight: 500;">Sick Leave Credits</span>
            </div>
            <div class="valign-wrapper">
              <span style="font-size: 3rem; font-weight: bold; margin-right: 10px; line-height: 1;">
                {{ balances?.sick_leave_credits || '0.0' }}
              </span>
              <span style="font-size: 1.1rem; opacity: 0.9;">Days Remaining</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading">
      
      <div class="row">
        <div class="col s12">
          <div class="card z-depth-1" style="border-radius: 8px; border: 1px solid #f5f5f5;">
            <div class="card-content">
              
              <div style="display: flex; gap: 15px; flex-wrap: wrap; margin-bottom: 30px;">
                <div class="skeleton" style="width: 160px; height: 44px; border-radius: 4px;" v-for="n in 3" :key="'skel-badge-' + n"></div>
              </div>

              <!-- DESKTOP SKELETON TABLE -->
              <div class="hide-on-med-and-down">
                <table class="highlight responsive-table" style="border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden;">
                  <thead class="grey lighten-4">
                    <tr>
                      <th style="padding-left: 20px; width: 24%;">Leave Type</th>
                      <th style="width: 20%;">Dates</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="n in 4" :key="'skel-row-' + n">
                      <td style="padding-left: 20px;" class="valign-wrapper">
                        <div class="skeleton" style="width: 24px; height: 24px; border-radius: 4px; margin-right: 10px;"></div>
                        <div class="skeleton" style="width: 40%; height: 16px; border-radius: 4px;"></div>
                      </td>
                      <td><div class="skeleton" style="width: 120px; height: 16px; border-radius: 4px;"></div></td>
                      <td><div class="skeleton" style="width: 185px; height: 28px; border-radius: 4px;"></div></td>
                      <td>
                        <div style="display: flex; gap: 8px;">
                          <div class="skeleton" style="width: 70px; height: 32px; border-radius: 4px;"></div>
                          <div class="skeleton" style="width: 80px; height: 32px; border-radius: 4px;"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- MOBILE SKELETON CARDS -->
              <div class="hide-on-large-only" style="margin-top: 15px;">
                <div style="display: flex; flex-direction: column; gap: 15px;">
                  <div v-for="n in 3" :key="'skel-mob-hist-' + n" class="card z-depth-0" style="margin: 0; border-radius: 8px; border: 1px solid #e0e0e0;">
                    <div class="card-content" style="padding: 15px;">
                      <div style="display: flex; justify-content: space-between; margin-bottom: 12px;">
                        <div class="skeleton" style="width: 50%; height: 24px; border-radius: 4px;"></div>
                        <div class="skeleton" style="width: 80px; height: 24px; border-radius: 4px;"></div>
                      </div>
                      <div class="skeleton" style="width: 70%; height: 16px; border-radius: 4px;"></div>
                    </div>
                    <div class="card-action" style="background-color: #f9f9f9; padding: 10px 15px; display: flex; justify-content: flex-end; gap: 10px; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                      <div class="skeleton" style="width: 70px; height: 32px; border-radius: 4px;"></div>
                      <div class="skeleton" style="width: 100px; height: 32px; border-radius: 4px;"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
    
    <div v-else>
      
      <div class="row" v-if="approverQueue.length > 0">
        <div class="col s12">
          <div class="card amber lighten-5" style="border: 1px solid #ffecb3; border-radius: 8px;">
            <div class="card-content action-card-content">
              
              <div class="amber-text text-darken-4 notification-text">
                <i class="material-icons">notification_important</i>
                <span>
                  Action Required: There are <strong>{{ approverQueue.length }}</strong> leave requests pending for your approval
                </span>
              </div>

              <router-link to="/leave-management" class="btn amber darken-3 waves-effect waves-light action-btn mobile-full-btn">
                View requests
                <i class="material-icons right" style="margin-left: 8px;">arrow_forward</i>
              </router-link>
              
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col s12">
          <div class="card z-depth-1" style="border-radius: 8px;">
            <div class="card-content">
              
              <!-- STATUS BADGES -->
              <div class="status-badges" style="display: flex; gap: 15px; flex-wrap: wrap; margin-bottom: 25px;">
                
                <div class="orange darken-1 white-text z-depth-1" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; border-radius: 4px; min-width: 160px; flex: 1;">
                  <div class="valign-wrapper"><i class="material-icons left" style="margin-right: 8px;">edit_document</i> <strong>Drafts</strong></div>
                  <span style="background: rgba(255,255,255,0.3); padding: 2px 8px; border-radius: 4px; font-weight: bold;">{{ draftCount }}</span>
                </div>
                
                <div class="amber darken-2 white-text z-depth-1" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; border-radius: 4px; min-width: 160px; flex: 1;">
                  <div class="valign-wrapper"><i class="material-icons left" style="margin-right: 8px;">pending_actions</i> <strong>Pending</strong></div>
                  <span style="background: rgba(255,255,255,0.3); padding: 2px 8px; border-radius: 4px; font-weight: bold;">{{ pendingCount }}</span>
                </div>

                <div class="green darken-1 white-text z-depth-1" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 15px; border-radius: 4px; min-width: 160px; flex: 1;">
                  <div class="valign-wrapper"><i class="material-icons left" style="margin-right: 8px;">check_circle</i> <strong>Approved</strong></div>
                  <span style="background: rgba(255,255,255,0.3); padding: 2px 8px; border-radius: 4px; font-weight: bold;">{{ approvedCount }}</span>
                </div>
                
              </div>

              <!-- DESKTOP REAL TABLE -->
              <div class="hide-on-med-and-down">
                <table class="highlight responsive-table" style="border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden;">
                  <thead class="grey lighten-4">
                    <tr>
                      <th style="padding-left: 20px;">Leave Type</th>
                      <th>Dates</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="myHistory.length === 0">
                      <td colspan="4" class="center-align grey-text" style="padding: 30px;">You don't have any leave requests</td>
                    </tr>
                    
                    <tr v-for="leave in myHistory" :key="leave.id">
                      <td style="padding-left: 20px;" class="bold valign-wrapper">
                        <i v-if="leave.leave_type.includes('Vacation')" class="material-icons green-text text-darken-1" style="margin-right: 10px;">work_outline</i>
                        <i v-else-if="leave.leave_type.includes('Sick')" class="material-icons blue-text text-darken-1" style="margin-right: 10px;">local_hospital</i>
                        <i v-else class="material-icons orange-text text-darken-1" style="margin-right: 10px;">event</i>
                        {{ leave.leave_type }}
                      </td>
                      
                      <td class="grey-text text-darken-2">{{ leave.inclusive_dates }}</td>
                      
                      <td>
                        <div class="chip bold" 
                             :class="{
                               'green lighten-4 green-text text-darken-4': leave.status === 'Approved',
                               'orange lighten-4 green-text text-darken-4': leave.status === 'In Progress' || leave.status === 'Pending',
                               'red lighten-4 red-text text-darken-4': leave.status === 'Disapproved' || leave.status === 'Cancelled',
                               'orange lighten-4 orange-text text-darken-4': leave.status === 'Returned' || leave.status === 'Draft'
                             }" 
                             style="border-radius: 4px; line-height: 28px; height: 28px;">
                          {{ leave.current_stage == "Completed" ? "Approved" : leave.current_stage }}
                        </div>
                      </td>
                      
                      <td>
                        <button @click="viewPdf(leave.id)" class="btn-small blue darken-2 waves-light" style="margin-right: 8px;">View</button>
                        <button v-if="leave.status === 'In Progress' || leave.status === 'Draft' || leave.status === 'Pending'" 
                                @click="confirmCancel(leave.id)"
                                class="btn-small white grey-text text-darken-3 outline-btn">
                          Cancel
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- MOBILE REAL DATA CARDS -->
              <div class="hide-on-large-only" style="margin-top: 15px;">
                <div v-if="myHistory.length === 0" class="center-align grey-text" style="padding: 30px; border: 1px dashed #ccc; border-radius: 8px;">
                  You don't have any leave requests
                </div>
                
                <div v-else style="display: flex; flex-direction: column; gap: 15px;">
                  <div v-for="leave in myHistory" :key="'mobile-' + leave.id" class="card z-depth-0" style="margin: 0; border-radius: 8px; border: 1px solid #e0e0e0;">
                    <div class="card-content" style="padding: 15px;">
                      
                      <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 12px;">
                        <div class="valign-wrapper bold" style="flex: 1; padding-right: 10px;">
                          <i v-if="leave.leave_type.includes('Vacation')" class="material-icons green-text text-darken-1" style="margin-right: 8px;">work_outline</i>
                          <i v-else-if="leave.leave_type.includes('Sick')" class="material-icons blue-text text-darken-1" style="margin-right: 8px;">local_hospital</i>
                          <i v-else class="material-icons orange-text text-darken-1" style="margin-right: 8px;">event</i>
                          <span style="font-size: 1.05rem; color: #1565c0; line-height: 1.2;">{{ leave.leave_type }}</span>
                        </div>
                        <div class="chip bold" 
                             :class="{
                               'green lighten-4 green-text text-darken-4': leave.status === 'Approved',
                               'orange lighten-4 green-text text-darken-4': leave.status === 'In Progress' || leave.status === 'Pending',
                               'red lighten-4 red-text text-darken-4': leave.status === 'Disapproved' || leave.status === 'Cancelled',
                               'orange lighten-4 orange-text text-darken-4': leave.status === 'Returned' || leave.status === 'Draft'
                             }" 
                             style="margin: 0; border-radius: 4px; height: 24px; line-height: 24px; font-size: 0.75rem;">
                          {{ leave.current_stage == "Completed" ? "Approved" : leave.current_stage }}
                        </div>
                      </div>
                      
                      <div class="grey-text text-darken-2 valign-wrapper" style="font-size: 0.95rem;">
                        <i class="material-icons left" style="font-size: 1.1rem; margin-right: 5px; color: #757575;">date_range</i> 
                        {{ leave.inclusive_dates }}
                      </div>
                    </div>
                    
                    <div class="card-action" style="padding: 10px 15px; background-color: #f9f9f9; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px; display: flex; justify-content: flex-end; gap: 10px;">
                      <button v-if="leave.status === 'In Progress' || leave.status === 'Draft' || leave.status === 'Pending'" 
                              @click="confirmCancel(leave.id)"
                              class="btn-small white grey-text text-darken-3 outline-btn" style="border-radius: 4px; box-shadow: none;">
                        Cancel
                      </button>
                      <button @click="viewPdf(leave.id)" class="btn-small blue darken-2 waves-light" style="border-radius: 4px; box-shadow: none;">
                        <i class="material-icons left" style="margin-right: 5px; font-size: 1rem;">description</i> View
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="right-align" style="margin-top: 25px;">
                <router-link to="/apply-leave" class="btn blue darken-2 waves-light valign-wrapper z-depth-2 mobile-full-btn" style="display: inline-flex; border-radius: 4px; font-weight: bold;">
                  <i class="material-icons left" style="margin-right: 8px;">add</i> Apply Leave
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- CANCEL CONFIRMATION MODAL -->
    <div id="cancelModal" class="modal custom-modal-center" style="width: 90%; max-width: 450px; border-radius: 8px;">
      <div class="modal-content center-align">
        <i class="material-icons red-text text-darken-2" style="font-size: 4rem; margin-bottom: 10px;">warning</i>
        <h5 style="margin-top: 0; font-weight: bold;">Cancel Application?</h5>
        <p class="grey-text text-darken-2" style="font-size: 1.1rem; margin-top: 15px;">
          Are you sure you want to cancel this leave application? This action cannot be undone.
        </p>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: center; gap: 15px; padding-bottom: 25px;">
        <button class="btn-flat modal-close waves-effect grey-text text-darken-2" :disabled="isCancelling" style="font-weight: bold;">
            Close
        </button>
        <button class="btn red darken-2 waves-light" @click="executeCancel" :disabled="isCancelling" style="border-radius: 4px;">
          <span v-if="isCancelling">Cancelling...</span>
          <span v-else>Confirm Cancellation</span>
        </button>
      </div>
    </div>

    <!-- NO BALANCE MODAL -->
    <div id="noBalanceModal" class="modal custom-modal-center" style="width: 90%; max-width: 450px; border-radius: 8px;">
      <div class="modal-content center-align">
        <i class="material-icons orange-text text-darken-2" style="font-size: 4rem; margin-bottom: 10px;">info_outline</i>
        <h5 style="margin-top: 0; font-weight: bold;">Leave Balances Not Found</h5>
        <p class="grey-text text-darken-2" style="font-size: 1.1rem; margin-top: 15px;">
          You currently do not have a leave balance record in the system. Please request your administrator to set up your current leave credits before applying.
        </p>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: center; gap: 15px; padding-bottom: 25px;">
        <button class="btn-flat waves-effect grey-text text-darken-2" @click="navigateBack" :disabled="isRequestingBalance" style="font-weight: bold;">
          Cancel
        </button>
        <button class="btn blue darken-2 waves-light" @click="requestBalanceSetup" :disabled="isRequestingBalance" style="border-radius: 4px;">
          <span v-if="isRequestingBalance">Requesting...</span>
          <span v-else>Request Setup</span>
        </button>
      </div>
    </div>
    
  </AdminAppLayout>
</template>

<script>
import api from '../../axios';
import AdminAppLayout from '../layout/AdminAppLayout.vue';

export default {
  name: "LeaveDashboardView",
  components: {
    AdminAppLayout
  },
  data() {
    return {
      loading: true,
      balances: null,
      myHistory: [],
      approverQueue: [],
      
      // Cancellation State
      leaveToCancel: null,
      isCancelling: false,
      
      // Request Setup State
      isRequestingBalance: false
    };
  },
  computed: {
    draftCount() {
      return this.myHistory.filter(leave => leave.status === 'Draft').length;
    },
    pendingCount() {
      return this.myHistory.filter(leave => leave.status === 'In Progress' || leave.status === 'Pending').length;
    },
    approvedCount() {
      return this.myHistory.filter(leave => leave.status === 'Approved').length;
    }
  },
  methods: {
    fetchDashboardData() {
      this.loading = true;
      
      api.get('/leave-dashboard')
        .then(response => {
          this.balances = response.data.leave_balances;
          this.myHistory = response.data.my_leave_history;
          this.approverQueue = response.data.action_required_queue;

          // Trigger the modal if no balance record exists
          if (!this.balances) {
            this.$nextTick(() => {
              if (window.M) {
                const modal = document.getElementById('noBalanceModal');
                let instance = window.M.Modal.getInstance(modal);
                
                instance = window.M.Modal.init(modal, { dismissible: false });
                
                instance.open();
              }
            });
          }
        })
        .catch(error => {
          console.error("Error fetching dashboard:", error);
          if (window.M) {
            window.M.toast({ html: 'Failed to load dashboard data.', classes: 'red' });
          } else {
            alert("Failed to load dashboard data.");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async viewPdf(applicationId) {
      try {
        const response = await api.get(`/leave-applications/${applicationId}/pdf`, { responseType: 'blob' });
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(pdfBlob);
        window.open(url, '_blank');
      } catch (error) {
        console.error("Error fetching PDF:", error);
        if (window.M) {
          window.M.toast({ html: 'Failed to load PDF.', classes: 'red' });
        } else {
          alert("Failed to load PDF.");
        }
      }
    },

    processLeave(applicationId, action, remarks = '') {
      api.post(`/leave-applications/${applicationId}/process`, {
        action: action,
        remarks: remarks
      })
      .then(() => {
        if (window.M) {
          window.M.toast({ html: `Application successfully marked as: ${action}`, classes: 'green' });
        }
        this.fetchDashboardData(); 
      })
      .catch((error) => {
        console.error("Error processing leave:", error);
        const errorMsg = error.response?.data?.error || "An error occurred.";
        if (window.M) {
          window.M.toast({ html: errorMsg, classes: 'red' });
        } else {
          alert(errorMsg);
        }
      });
    },

    promptAction(applicationId, action) {
      const remarks = prompt(`Please enter your remarks for why you are going to ${action} this application:`);
      
      if (remarks === null) return; 
      
      if (remarks.trim() === '') {
        alert("Remarks are required for returning or disapproving!");
        return;
      }

      this.processLeave(applicationId, action, remarks);
    },

    // --- CANCELLATION METHODS ---
    confirmCancel(applicationId) {
      this.leaveToCancel = applicationId;
      if (window.M) {
        const modal = document.getElementById('cancelModal');
        const instance = window.M.Modal.getInstance(modal);
        instance.open();
      }
    },

    async requestBalanceSetup() {
      this.isRequestingBalance = true;

      try {
        await api.post('/leave-balances/request-setup');
        
        if (window.M) {
          window.M.toast({ html: 'Request sent to administrator queue.', classes: 'green' });
          const modal = document.getElementById('noBalanceModal');
          const instance = window.M.Modal.getInstance(modal);
          if (instance) instance.close();
        }
      } catch (error) {
        // This will automatically catch the 422 duplicate error and display it
        const errorMsg = error.response?.data?.error || "Failed to send request.";
        if (window.M) window.M.toast({ html: errorMsg, classes: 'red' });
      } finally {
        this.isRequestingBalance = false;
        this.navigateBack();
      }
    },

    async executeCancel() {
      if (!this.leaveToCancel) return;
      
      this.isCancelling = true;

      try {
        await api.post(`/leave-applications/${this.leaveToCancel}/cancel`);
        
        if (window.M) {
          window.M.toast({ html: 'Leave application cancelled successfully.', classes: 'green' });
          const modal = document.getElementById('cancelModal');
          const instance = window.M.Modal.getInstance(modal);
          if (instance) instance.close();
        }
        
        // Refresh the table data
        this.fetchDashboardData();

      } catch (error) {
        console.error("Error cancelling leave:", error);
        const errorMsg = error.response?.data?.error || "Failed to cancel application.";
        if (window.M) {
          window.M.toast({ html: errorMsg, classes: 'red' });
        } else {
          alert(errorMsg);
        }
      } finally {
        this.isCancelling = false;
        this.leaveToCancel = null;
      }
    },

    navigateBack() {
      // Close the modal to remove the dark overlay
      if (window.M) {
        const modal = document.getElementById('noBalanceModal');
        const instance = window.M.Modal.getInstance(modal);
        if (instance && instance.isOpen) {
          instance.close();
        }
      }

      // Wait for Materialize's closing animation before changing the route
      setTimeout(() => {
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          this.$router.push('/'); // Fallback if they opened the link directly
        }
      }, 300);
    },
  },
  mounted() {
    this.fetchDashboardData();
    
    // Initialize modals so they work correctly
    this.$nextTick(() => {
      if (window.M) {
        const modals = document.querySelectorAll('.modal');
        window.M.Modal.init(modals);
      }
    });
  }
};
</script>

<style scoped>
/* Custom outline button for the Cancel action to match Materialize styling but with an outline */
.outline-btn {
  border: 1px solid #bdbdbd !important;
  box-shadow: none !important;
}
.outline-btn:hover {
  background-color: #f5f5f5 !important;
}

/* Ensure Materialize icons align perfectly in buttons/chips */
.valign-wrapper i {
  display: flex;
  align-items: center;
}

.action-card-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between; /* Pushes text left, button right */
  align-items: center; /* Centers them vertically */
  padding: 16px 24px;
  gap: 16px; /* Adds a little breathing room if they get too close */
}

.notification-text {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1.05rem;
  line-height: 1.4;
}

.notification-text i {
  margin-right: 12px;
  font-size: 1.8rem;
}

.action-btn {
  border-radius: 6px;
  font-weight: bold;
  white-space: nowrap; /* Prevents the button text from wrapping onto two lines */
}

.custom-modal-center.modal {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) scale(1) !important;
  margin: 0 !important;
}

.custom-modal-center.modal:not(.open) {
  transform: translate(-50%, -50%) scale(0.8) !important;
}

/* Mobile Responsive Adjustments */
@media only screen and (max-width: 768px) {
  .status-badges {
    flex-direction: column !important;
  }
  .status-badges > div {
    width: 100% !important;
    margin-bottom: 5px;
  }
  .action-card-content {
    flex-direction: column !important;
    text-align: center;
  }
  .notification-text {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
  .notification-text i {
    margin-right: 0;
  }
  .action-btn {
    width: 100%;
  }
  .mobile-full-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>